import { z } from "zod";

/** Service names that sign and receive internal JWTs (D-082). */
export const SERVICES = ["api", "worker", "console-api", "billing"] as const;
export type ServiceName = (typeof SERVICES)[number];

/** Claims of the 60-second Ed25519 service JWT. `act` carries the end user on whose behalf a call is made. */
export const ServiceJwtClaims = z.object({
  iss: z.enum(SERVICES),
  aud: z.enum(SERVICES),
  iat: z.number().int(),
  exp: z.number().int(),
  jti: z.string().min(8),
  act: z.object({ oid: z.string().min(1), tid: z.string().min(1) }).optional(),
});
export type ServiceJwtClaims = z.infer<typeof ServiceJwtClaims>;

export const SERVICE_JWT_MAX_TTL_SECONDS = 60;
